import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { GENERATE_TINY_URL_AND_TOKEN } from 'shared/mutations';
import { env } from 'env';
import { useToast } from '@televet/kibble-ui/build/components/Toast';

interface INavigateToFormSubmissionInput {
  formSubmissionId: string;
  clinicPetParentId: string;
}

interface IUseNavigateToFormSubmissionOutput {
  navigateToFormSubmission: (input: INavigateToFormSubmissionInput) => Promise<void>;
}

const useNavigateToFormSubmission = (): IUseNavigateToFormSubmissionOutput => {
  const toast = useToast();

  const [getTinyUrlAndToken] = useMutation(GENERATE_TINY_URL_AND_TOKEN);

  const navigateToFormSubmission = async ({
    formSubmissionId,
    clinicPetParentId,
  }: INavigateToFormSubmissionInput): Promise<void> => {
    try {
      // Safari blocks async window.open() calls that come after an await - they must be in direct
      // response to the triggering event
      const newWindow = window.open();

      const response = await getTinyUrlAndToken({
        variables: {
          data: {
            clinicPetParentId,
          },
        },
      });
      const token = response?.data?.generateTinyUrlAndToken?.token;
      const editorPath = `${env.REACT_APP_PET_WEB_URL}/forms/${formSubmissionId}?token=${token}&forceEdit=true`;
      if (newWindow) newWindow.location.href = editorPath;
    } catch (e) {
      Sentry.captureException(e);
      toast({
        status: 'error',
        title: "Whoops! We're unable to retrieve the form at this time.",
      });
    }
  };

  return {
    navigateToFormSubmission,
  };
};

export default useNavigateToFormSubmission;
